export const MediaFileType = Object.freeze({
	IMAGE: 1,
	AUDIO: 2,
	VIDEO: 3,
	PDF: 4,
});

export const getMediaTypeName = (mediaFileType, resources = {}) => {
	switch (mediaFileType) {
		case MediaFileType.IMAGE:
			return resources["Image"];
		case MediaFileType.AUDIO:
			return resources["Audio"];
		case MediaFileType.VIDEO:
			return resources["Video"];
		case MediaFileType.PDF:
			return resources["PDF"];
		default:
			return resources["File"];
	}
};

export const parseMediaFileType = (mime) => {
	if (!mime) {
		throw new Error("Missing mime type");
	}

	const mimeType = mime.toLowerCase();

	if (mimeType.includes("image")) return MediaFileType.IMAGE;
	if (mimeType.includes("audio")) return MediaFileType.AUDIO;
	if (mimeType.includes("video")) return MediaFileType.VIDEO;
	if (mimeType.includes("pdf")) return MediaFileType.PDF;

	throw new Error(`Unknown media file type: ${mimeType}`);
};
